import { Component, Inject, Injector, OnInit, ChangeDetectionStrategy, inject, signal } from '@angular/core'
import { FieldTree, form, required, validate } from '@angular/forms/signals'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { DateService } from '@lemon/core/service/date.service'

export interface AsiakkaanMaksutavatPoistaTilitapahtumatDialogData {
  asiakasAvain: string
  iban: string
}

export interface AsiakkaanMaksutavatPoistaTilitapahtumatDialogResult {
  start: number
  end: number
}

interface VahvistusLomake {
  vahvistus: string
  start: Date | null
  end: Date | null
}

@Component({
  templateUrl: './asiakkaan-maksutavat-poista-tilitapahtumat.dialog.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class AsiakkaanMaksutavatPoistaTilitapahtumatDialog implements OnInit {
  lomake: FieldTree<VahvistusLomake>
  private readonly _injector = inject(Injector)

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: AsiakkaanMaksutavatPoistaTilitapahtumatDialogData,
    private _dialogRef: MatDialogRef<AsiakkaanMaksutavatPoistaTilitapahtumatDialog>,
    private _dateService: DateService,
  ) {}

  ngOnInit() {
    this.lomake = form(
      signal<VahvistusLomake>({ vahvistus: '', start: null, end: null }),
      polku => {
        required(polku.vahvistus)
        validate(polku.vahvistus, ({ value }) => (value() === this.data.iban ? null : { kind: 'ibanMismatch' }))
        required(polku.start)
        required(polku.end)
      },
      { injector: this._injector },
    )
  }

  poista() {
    if (!this.lomake().valid()) {
      this.lomake().markAsTouched()
      return
    }
    const result: AsiakkaanMaksutavatPoistaTilitapahtumatDialogResult = {
      start: this._dateService.dateToNumber(this.lomake.start().value()),
      end: this._dateService.dateToNumber(this.lomake.end().value()),
    }
    this._dialogRef.close(result)
  }

  onkoVirhe<T>(kentta: FieldTree<T>, laji: string) {
    return kentta()
      .errors()
      .some(virhe => virhe.kind === laji)
  }

  peruuta() {
    this._dialogRef.close(null)
  }
}
